// extracted by mini-css-extract-plugin
module.exports = {"dailyRewardTimer":"DailyRewardCountdownText_dailyRewardTimer__31Y0m","clock":"DailyRewardCountdownText_clock__2OqxL"};